import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2 ResponsiveStartAudit"
}
const _hoisted_2 = { class: "items-center justify-between flex ResponsiveStartAudit" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex parent-toggle-border border rounded-sm border-lightgrey bg-white" }
const _hoisted_7 = { class: "mt-5 ResponsiveStartAudit table-section" }
const _hoisted_8 = { class: "table-data-root" }
const _hoisted_9 = { class: "table-card-shell tableCornerRadius bg-white" }
const _hoisted_10 = { class: "table-card-inner" }
const _hoisted_11 = { class: "table-container table-container-fit" }
const _hoisted_12 = { class: "table-header-wrap" }
const _hoisted_13 = { class: "table-header-row" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onMousemove"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = {
  key: 5,
  class: "pl-5"
}
const _hoisted_22 = { key: 6 }
const _hoisted_23 = ["onMousedown"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "table-body-scroll" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_36 = ["colspan"]
const _hoisted_37 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_38 = {
  key: 1,
  class: "empty"
}
const _hoisted_39 = { class: "cursor-pointer rowHeight" }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "h-full w-full flex items-center"
}
const _hoisted_44 = {
  key: 0,
  class: "h-full w-full flex flex-wrap items-center"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  class: "pl-4"
}
const _hoisted_47 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_48 = { key: 3 }
const _hoisted_49 = ["onMousemove"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_52 = { class: "popup-business" }
const _hoisted_53 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_54 = { class: "formcontainer flex flex-col" }
const _hoisted_55 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_56 = { class: "w-1/2 px-2" }
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "w-1/2 px-2" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_61 = { class: "w-1/2 px-2" }
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "w-1/2 px-2" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_66 = { class: "popup-business" }
const _hoisted_67 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_68 = { class: "formcontainer flex flex-col" }
const _hoisted_69 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_70 = { class: "w-full px-1" }
const _hoisted_71 = { class: "inputboxstyling" }
const _hoisted_72 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_73 = { class: "w-full px-1" }
const _hoisted_74 = { class: "inputboxstyling" }
const _hoisted_75 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_76 = { class: "w-full px-1" }
const _hoisted_77 = { class: "inputboxstyling" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal page-fill' : 'pt-3 px-5 pb-2 page-fill')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.presentAudit.title), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'myControls', 'inactive-tab': _ctx.activeButton !== 'myControls' }, "flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs"]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMyControls && _ctx.showMyControls(...args)))
          }, " My Tasks ", 2),
          _createElementVNode("button", {
            class: _normalizeClass([{ 'active-tab': _ctx.activeButton === 'allControls', 'inactive-tab': _ctx.activeButton !== 'allControls' }, "flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs"]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showAllControls && _ctx.showAllControls(...args)))
          }, " All Tasks ", 2)
        ]),
        _createElementVNode("button", {
          class: "filterButton ml-3 flex",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "filterIcon"
          }, null, -1),
          _createTextVNode(" Filters ")
        ]))
      ])
    ]),
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "mt-5 ResponsiveStartAudit" }, [
      _createElementVNode("p", { class: "headerText" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
    ], -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", {
                  class: "table-fit-card table-header-table",
                  style: _normalizeStyle(_ctx.tableResizeStyle)
                }, [
                  _createElementVNode("colgroup", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: 'h-'+column,
                        style: _normalizeStyle(_ctx.columnStyle(column))
                      }, null, 4))
                    }), 128))
                  ]),
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                        return (_openBlock(), _createElementBlock("th", {
                          scope: "col",
                          key: column,
                          class: _normalizeClass(["bg-white th1 cursor-pointer capitalize resizable-th", _ctx.getColumnHeadWidth(column)]),
                          style: _normalizeStyle(_ctx.columnStyle(column)),
                          onClick: ($event: any) => (_ctx.onHeaderClick(column)),
                          onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doFalse()))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex table-header-label-wrap", _ctx.getPaddingForColumn(column)])
                          }, [
                            _createElementVNode("div", {
                              class: "table-header-label",
                              onMousemove: ($event: any) => (_ctx.headerToolTip(column, $event))
                            }, [
                              (column == 'auditStatus')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[10] || (_cache[10] = [
                                    _createElementVNode("div", null, _toDisplayString('Status'), -1)
                                  ])))
                                : (column == 'controlNumber')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[11] || (_cache[11] = [
                                      _createElementVNode("div", null, _toDisplayString('Control '), -1)
                                    ])))
                                  : (column == 'taskId')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[12] || (_cache[12] = [
                                        _createElementVNode("div", null, _toDisplayString('ID'), -1)
                                      ])))
                                    : (column == 'controlName')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[13] || (_cache[13] = [
                                          _createElementVNode("div", null, _toDisplayString('Title'), -1)
                                        ])))
                                      : (column == 'dueDate')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[14] || (_cache[14] = [
                                            _createElementVNode("div", null, _toDisplayString('Due Date'), -1)
                                          ])))
                                        : (_ctx.isColumnFrameWork(column))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(column), 1))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(column), 1))
                            ], 40, _hoisted_15),
                            (!_ctx.isColumnFrameWork(column))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: "column-resize-handle",
                            onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, column)), ["stop","prevent"])
                          }, null, 40, _hoisted_23),
                          (_ctx.pop == true && _ctx.tipColumn == column && _ctx.tipIndex == 'header')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createVNode(_component_tool_tip, {
                                  columnName: column,
                                  tipText: _ctx.tipText,
                                  styling: _ctx.styling
                                }, null, 8, ["columnName", "tipText", "styling"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 46, _hoisted_14))
                      }), 128))
                    ]),
                    (_ctx.showFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (name) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: _normalizeClass(["bg-white", _ctx.getColumnHeadWidth(name)]),
                              key: name,
                              style: _normalizeStyle(_ctx.columnStyle(name))
                            }, [
                              (_ctx.isColumnFrameWork(name))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                                : (name == 'auditStatus')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 1,
                                      class: _normalizeClass(["inputboxstylingForSelect mx-auto filterwidth", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                    }, [
                                      _createElementVNode("option", {
                                        value: _ctx.filterDummy.name,
                                        selected: "",
                                        hidden: "",
                                        disabled: ""
                                      }, "Select", 8, _hoisted_28),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditStatusCodes, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.value), 9, _hoisted_29))
                                      }), 128))
                                    ], 10, _hoisted_27)), [
                                      [_vModelSelect, _ctx.filterDummy[name]]
                                    ])
                                  : ( name == 'dueDate')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                                    : (name == 'controlNumber')
                                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 3,
                                          type: "text",
                                          class: "inputboxstylingForControlID",
                                          placeholder: "Search",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                        }, null, 8, _hoisted_31)), [
                                          [
                                            _vModelText,
                                            _ctx.filterDummy[name],
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 4,
                                          type: "text",
                                          class: "searchForInputBoxStyling",
                                          placeholder: "Search",
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                        }, null, 8, _hoisted_32)), [
                                          [
                                            _vModelText,
                                            _ctx.filterDummy[name],
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                            ], 6))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("table", {
                  class: "table-fit-card",
                  style: _normalizeStyle(_ctx.tableResizeStyle)
                }, [
                  _createElementVNode("colgroup", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                      return (_openBlock(), _createElementBlock("col", {
                        key: 'b-'+column,
                        style: _normalizeStyle(_ctx.columnStyle(column))
                      }, null, 4))
                    }), 128))
                  ]),
                  (_ctx.dataLoading == true)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_34, [
                        _createElementVNode("tr", _hoisted_35, [
                          _createElementVNode("td", {
                            class: "relative h-5",
                            colspan: _ctx.columnNames.size
                          }, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_dots_loader)
                            ])
                          ], 8, _hoisted_36)
                        ])
                      ]))
                    : (_ctx.sortedData.length == 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                          _createElementVNode("tr", _hoisted_39, [
                            _createElementVNode("td", {
                              class: "relative h-10",
                              colspan: _ctx.columnNames.size
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("div", { class: "flex justify-center" }, [
                                _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                              ], -1)
                            ]), 8, _hoisted_40)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: "rowHeight",
                              onClick: ($event: any) => (_ctx.goToControlTaskEdit(row._id))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: presentColumn,
                                  onMouseout: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doFalse())),
                                  class: _normalizeClass(["cursor-pointer relative", _ctx.getColumnHeadWidth(presentColumn)]),
                                  style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                                }, [
                                  (_ctx.isColumnFrameWork(presentColumn))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        (row[presentColumn].length>0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[presentColumn], (ctrlNumber) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  onClick: ($event: any) => (_ctx.clickedOnFrameWorkControlNumber(ctrlNumber,presentColumn)),
                                                  key: ctrlNumber,
                                                  class: _normalizeClass([_ctx.getBorder(), "text-xs m-2 px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center"])
                                                }, _toDisplayString(ctrlNumber), 11, _hoisted_45))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString('N/A')))
                                      ]))
                                    : (presentColumn == 'auditStatus')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-32", _ctx.colorAuditBg(row.auditStatus)])
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(_ctx.colorAuditText(row.auditStatus))
                                            }, _toDisplayString((_ctx.auditStatusCodes.find((l) => {
                                                    return l.id == row[presentColumn];
                                                }) || {}).value || '-'), 3)
                                          ], 2)
                                        ]))
                                      : (presentColumn =='dueDate')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: _normalizeClass(["flex items-center justify-center w-20 rounded h-5 mx-auto", _ctx.shouldStyleDueDate(row) ? _ctx.colorForDueDate(row[presentColumn]) : ''])
                                          }, _toDisplayString(row[presentColumn]), 3))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            _createElementVNode("div", {
                                              class: "table-ellipsis",
                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                            }, _toDisplayString(row[presentColumn]), 41, _hoisted_49),
                                            (_ctx.pop == true && _ctx.tipColumn == presentColumn && _ctx.tipIndex == index)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                  _createVNode(_component_tool_tip, {
                                                    columnName: presentColumn,
                                                    tipText: _ctx.tipText,
                                                    styling: _ctx.styling
                                                  }, null, 8, ["columnName", "tipText", "styling"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                ], 38))
                              }), 128))
                            ], 8, _hoisted_42))
                          }), 128))
                        ]))
                ], 4)
              ])
            ]),
            _createVNode(_component_pagination, {
              dynamicPagination: _ctx.dynamicPagination,
              onCurrentPageUpdate: _ctx.paginationUpdations,
              sortedData: _ctx.sortedData
            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
          ])
        ])
      ])
    ]),
    (_ctx.addControlPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.addControlPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_51, [
              _cache[17] || (_cache[17] = _createElementVNode("h1", null, "New Control", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onCloseAddPopup()))
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Control Number", -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("input", {
                            class: "inputboxstyling",
                            placeholder: "Control Number",
                            value: _ctx.controlAddObject.controlNumber
                          }, null, 8, _hoisted_57)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Title", -1)),
                          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("input", {
                            class: "inputboxstyling",
                            placeholder: "Title",
                            value: _ctx.controlAddObject.controlTitle
                          }, null, 8, _hoisted_59)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Team", -1)),
                          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "inputboxstyling",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.controlAddObject.team) = $event))
                          }, [
                            _cache[22] || (_cache[22] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamObject, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option,
                                value: option.value
                              }, _toDisplayString(option.label), 9, _hoisted_62))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.controlAddObject.team]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Location", -1)),
                          _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "inputboxstyling",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.controlAddObject.entity) = $event))
                          }, [
                            _cache[25] || (_cache[25] = _createElementVNode("option", {
                              value: "",
                              selected: "",
                              disabled: "",
                              hidden: ""
                            }, "Please select one", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationObject, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option,
                                value: option.value
                              }, _toDisplayString(option.label), 9, _hoisted_64))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.controlAddObject.entity]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.viewControlNumberPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.viewControlNumberPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.frameWorkControlNumberObject.selectedFrameWork), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCloseFrameWorkControl()))
              }, _cache[28] || (_cache[28] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Frame Work No:", -1)),
                          _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.frameWorkControlNumberObject.controlNumber), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Title", -1)),
                          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.frameWorkControlNumberObject.controlTitle), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Description", -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.frameWorkControlNumberObject.description), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}